import { useEffect, useState } from 'react';
import * as yup from 'yup';
import { axiosInstance } from '../../../../../api/axios';
import APIEndpoints from '../../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';

const useOneTimePassword = ({
  email,
  nextStep,
  OTPExpiry,
  OTPLength,
  OTPAttempts,
}) => {
  const [serverError, setServerError] = useState(false);
  const [oneTimePassword, setOneTimePassword] = useState('');
  const [accountLocked, setAccountLocked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [timers, setTimers] = useState(parseInt(OTPExpiry || 5) * 60);
  const timerId = null;

  const schema = yup.object({
    oneTimePassword: yup
      .string()
      .matches(
        /^[0-9]*$/,
        'Enter your ' + OTPLength + '-digit authentication code',
      )
      .min(OTPLength, 'Enter your ' + OTPLength + '-digit authentication code')
      .max(OTPLength, 'Enter your ' + OTPLength + '-digit authentication code')
      .required('Enter your ' + OTPLength + '-digit authentication code'),
  });

  const maskEmail = (email) => {
    if (email) {
      const emailLength = email?.length;

      const pos = email.indexOf('@');
      return (
        email.substring(0, 3) +
        email.substring(3, pos).replace(/[a-z,A-Z]/gi, 'x') +
        email.substring(pos, emailLength)
      );
    }
  };

  const validateOTP = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get(
        APIEndpoints.getOtpVerifyResources() +
          oneTimePassword +
          '/userid/' +
          email,
      );
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        setLoader(false);
        return new Promise((resolve, reject) => {
          resolve('success');
        });
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('Unable to verify your OTP code now.');
        });
      }
    } catch (e) {
      if (e.response.status === 400) {
        let failedCount = false;
        const errorMessage = e.response.data.message.replace(/[\\["\]]/g, '');
        errorMessage.indexOf('Account locked') > 0
          ? setAccountLocked(true)
          : setAccountLocked(false);
        errorMessage.indexOf('Failed count') > 0
          ? (failedCount = true)
          : (failedCount = false);
        const attemptedCount = parseInt(
          errorMessage.substring(errorMessage.length - 1, errorMessage.length),
        );
        const pendingAttempts = OTPAttempts - attemptedCount;

        if (accountLocked || pendingAttempts < 0) {
          setAccountLocked(true);
          setLoader(false);
        } else if (failedCount) {
          setLoader(false);
          return new Promise((resolve, reject) => {
            reject(`Invalid OTP. 
              ${pendingAttempts === 0 ? 'Final' : pendingAttempts + 1} 
              ${pendingAttempts <= 1 ? 'Attempt' : 'Attempts'} Left.`);
          });
        } else {
          setLoader(false);
          return new Promise((resolve, reject) => {
            reject('Unable to verify your OTP code now.');
          });
        }
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('Unable to verify your OTP code now.');
        });
      }
    }
  };
  //const timer = ( remaining ) => {
  //clearTimeout( timerId );
  //let s = remaining % 60;
  //let m = Math.floor( remaining / 60 );

  //m = m < 10 ? '0' + m : m;
  //s = s < 10 ? '0' + s : s;

  //const element = document.getElementById( 'otp-timer' );

  //if ( element )
  //element.innerHTML = m + ':' + s;

  //remaining -= 1;

  //if ( remaining >= 0 ) {
  //timerId = setTimeout( () => {
  //timer( remaining );
  //}, 1000 );

  //return ()=>{
  //clearTimeout( timerId );
  //};
  //}
  //};
  useEffect(() => {
    let interval;
    let s = timers % 60;
    let m = Math.floor(timers / 60);

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;

    const element = document.getElementById('otp-timer');

    if (element) element.innerHTML = m + ':' + s;
    //Update the timer every second
    if (timers > 0) {
      interval = setInterval(() => {
        setTimers((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    //Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [timers]);

  const generateOTP = async () => {
    try {
      const response = await axiosInstance.get(
        APIEndpoints.getOtpGenerateResources() + email,
      );
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        const OTPExpiryTimeout = parseInt(OTPExpiry || 5) * 60;
        setTimers(OTPExpiryTimeout);
        //timer( OTPExpiryTimeout );
      } else {
        setServerError(true);
      }
    } catch (e) {
      setServerError(true);
    }
  };

  useEffect(() => {
    generateOTP();
  }, []);

  return {
    schema,
    serverError,
    accountLocked,
    loader,
    maskEmail,
    validateOTP,
    generateOTP,
    setOneTimePassword,
  };
};
export default useOneTimePassword;
